import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ToggleClickButton from "../../../../../components/Universal/ToggleClickButton.component";
import FilterBtn from "../../../../../components/Universal/FilterBtn.component";
import UpcomingExamCard from "../../../../../components/PagesComponents/Operational/Academic/Exams/ExamOverview/UpcomingExamCard.component";
import CardHeader from "../../../../../components/Universal/CardHeader.component";
import TogglePushBtn from "../../../../../components/Universal/TogglePushBtn.component";
// icons
import { ReactComponent as PersonIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/Person.svg";
import { ReactComponent as PersonInMobileFilterIcon } from "../../../../../assets/Icons/Pages/Operational/Academic/Attendance/PersonInMobile.svg";
import ExamHistoryTable from "../../../../../components/PagesComponents/Operational/Academic/Exams/ExamOverview/ExamHistoryTable.component";
import SecondModal from "../../../../../components/Universal/SecondModal.component";
import { Formik } from "formik";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import MultiOptionsSelectorInput from "../../../../../components/Universal/MultiOptionsSelectorInput.component";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import DownloadExamReport from "../../../../../components/PagesComponents/Operational/Academic/Exams/ExamOverview/DownloadExamReport.component";
import PlusIcon from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import ArrowRightIcon from "../../../../../assets/Icons/Universal/ArrowRightIcon.svg";

const Body = ({
  examHistoryVal,
  setExamHistoryVal,
  addExamModal,
  setAddExamModal,
  historyViewerModal,
  setHistoryViewerModal,
  scrollHeaderOverviewContainerRef,
  handelScroll,
  scrollHeaderOverviewContainer,
}) => {
  return (
    <section className="examsPage">
      <SecondModal isOpen={addExamModal} onClose={setAddExamModal}>
        <Formik
          initialValues={{
            gender: "",
            title: "",
            conductorName: "",
            startingDate: "",
            endingDate: "",
            venue: "",
            participatingClass: [],
          }}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ touched, setFieldValue, values, handleSubmit, errors }) => {
            return (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="flex-col align-start justify-start g-1"
              >
                <div className="flex-row align-center justify-between g-3">
                  <h3 className="t-20 poppins color-grayColor weight-500">
                    Add exams
                  </h3>
                  <div className="flex-row align-center g-1">
                    <TogglePushBtn
                      type="radio"
                      setVal={(val) =>
                        setFieldValue("gender", val.toLowerCase())
                      }
                      name="gender"
                      value={values.gender}
                      icon={
                        <PersonIcon
                          fill="white"
                          style={{ width: "1.3rem", height: "1.3rem" }}
                        />
                      }
                      icontype="svg"
                      label="All"
                    />
                    <TogglePushBtn
                      type="radio"
                      setVal={(val) =>
                        setFieldValue("gender", val.toLowerCase())
                      }
                      name="gender"
                      value={values.gender}
                      icon={
                        <PersonInMobileFilterIcon
                          fill="white"
                          style={{ width: "1.3rem", height: "1.3rem" }}
                        />
                      }
                      icontype="svg"
                      label="Boys"
                    />
                    <TogglePushBtn
                      type="radio"
                      setVal={(val) =>
                        setFieldValue("gender", val.toLowerCase())
                      }
                      name="gender"
                      value={values.gender}
                      icon={
                        <PersonInMobileFilterIcon
                          fill="white"
                          style={{ width: "1.3rem", height: "1.3rem" }}
                        />
                      }
                      icontype="svg"
                      label="Girls"
                    />
                  </div>
                  <button
                    type="button"
                    className="t-25 color-grayColor transparentCardBtn"
                    style={{ border: "none" }}
                    onClick={() => setAddExamModal(false)}
                  >
                    X
                  </button>
                </div>
                <div className="flex-row align-start justify-start g-2">
                  <div className="w-half flex-col align-start justify-start g-1">
                    <FormInput
                      label="Exam Name"
                      name="title"
                      placeholder={"Enter exam name"}
                      type="text"
                      errors={errors}
                      touched={touched}
                    />
                    <DatePicker
                      label="Starting Date"
                      name="startingDate"
                      setFieldValue={(val) =>
                        setFieldValue("startingDate", val)
                      }
                      placeholder={"Choose starting Date"}
                      errors={errors}
                    />
                    <DatePicker
                      label="Ending Date"
                      name="endingDate"
                      setFieldValue={(val) => setFieldValue("endingDate", val)}
                      placeholder={"Choose ending Date"}
                      errors={errors}
                    />
                    <FormInput
                      label="Venue"
                      name="venue"
                      placeholder={"Enter venue address"}
                      type="text"
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="w-half flex-col align-start justify-start g-1">
                    <FormInput
                      label="Conduct by"
                      name="conductorName"
                      placeholder={"Enter conductor name"}
                      type="text"
                      errors={errors}
                      touched={touched}
                    />

                    <MultiOptionsSelectorInput
                      label={"Select participating classes"}
                      setFieldValue={(val) =>
                        setFieldValue("participatingClass", val)
                      }
                      values={values.participatingClass}
                      options={[
                        "All Classes",
                        "Class 6",
                        "Class 5",
                        "Class 4",
                        "Class 7",
                      ]}
                    />
                  </div>
                </div>

                <button type="submit" className="actionBtn w-full">
                  Create
                </button>
              </form>
            );
          }}
        </Formik>
      </SecondModal>

      <ScrollableModal
        isOpen={true}
        // historyViewerModal
        onClose={setHistoryViewerModal}
      >
        <DownloadExamReport />
      </ScrollableModal>

      <Helmet>
        <title>Exams</title>
      </Helmet>

      
      <PageHeader
        title={"Upcoming examinations"}
        renderCustomElement={
          <div className="flex-row g-05 align-center justify-start">
            <FilterBtn btnTitle={"Filter"} filterArray={[""]} />

            <ToggleClickButton
              style={{ height: "2.5rem" }}
              label="All exam routines"
              onclick={({ inputVal }) => console.log(inputVal)}
              btnVal={"All exam routines"}
            />
          </div>
        }
      />
      {/* Upcoming examinations short cars  */}
      <div className="w-full h-fit relative ">
        {scrollHeaderOverviewContainer > 0 && (
          <button
            type="button"
            style={{
              width: "2.5rem",
              height: "2.5rem",
              borderRadius: "50%",
              background: "black",
              position: "absolute",
              left: 20,
              top: "30%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px",
              border: "none",
              outline: "none",
              cursor: "pointer",
              zIndex: 10,
            }}
            onClick={() => handelScroll("left")}
          >
            <img
              src={ArrowRightIcon}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transform: "rotate(180deg)",
              }}
            />
          </button>
        )}

        <div
          className="w-full h-fit scroll-x p-b-05 "
          ref={scrollHeaderOverviewContainerRef}
        >
          <div
            className="flex-row align-center justify-center g-1 w-fit"
            style={{ height: "101px" }}
          >
            <button
              onClick={() => setAddExamModal(true)}
              className="flex-row align-center justify-center g-05 radius-10 border-greenColor greenBack relative pointer p-1 h-full"
              style={{ width: "13.5rem" }}
            >
              <img
                src={PlusIcon}
                alt=""
                style={{ width: "1.5rem", height: "1.5rem" }}
              />
              <span className="t-16 poppins color-greenColor text-no-wrap">
                Add exam
              </span>
            </button>
            {[...Array(10)].map((_, index) => {
              return (
                <UpcomingExamCard
                  key={index + 10}
                  title=" First Terminal Examination"
                  description="27 Dec, 2024 - 07 Jan, 2025"
                  path={`examDetails/${index}`}
                />
              );
            })}
          </div>
        </div>

        <button
          type="button"
          style={{
            width: "2.5rem",
            height: "2.5rem",
            borderRadius: "50%",
            background: "black",
            position: "absolute",
            right: 20,
            top: "30%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
            border: "none",
            outline: "none",
            cursor: "pointer",
            zIndex: 10,
          }}
          onClick={() => handelScroll("right")}
        >
          <img
            src={ArrowRightIcon}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </button>
      </div>

      {/* all examination history  */}
      <div className="w-full flex-col align-start justify-start flex-1 back-white radius-13 p-2 overflow-hide">
        <CardHeader
          headerStyle={{ height: "4rem" }}
          title="All past examinations"
          actionBtn={
            <ExaminationHistoryShowTableActionBtns
              examHistoryVal={examHistoryVal}
              setExamHistoryVal={setExamHistoryVal}
            />
          }
        />
        <div className="flex-1 h-full scroll-y pr-1">
          <ExamHistoryTable />
        </div>
      </div>
    </section>
  );
};

export default Body;

const ExaminationHistoryShowTableActionBtns = ({
  examHistoryVal,
  setExamHistoryVal,
}) => {
  return (
    <div className="flex-row align-center justify-start g-05">
      <TogglePushBtn
        type="radio"
        setVal={(val) => setExamHistoryVal(val.toLowerCase())}
        name="examreportToggle"
        value={examHistoryVal}
        icon={
          <PersonIcon
            fill="white"
            style={{ width: "1.3rem", height: "1.3rem" }}
          />
        }
        icontype="svg"
        label="All"
      />
      <TogglePushBtn
        type="radio"
        setVal={(val) => setExamHistoryVal(val.toLowerCase())}
        name="examreportToggle"
        value={examHistoryVal}
        icon={
          <PersonInMobileFilterIcon
            fill="white"
            style={{ width: "1.3rem", height: "1.3rem" }}
          />
        }
        icontype="svg"
        label="Boys"
      />
      <TogglePushBtn
        type="radio"
        setVal={(val) => setExamHistoryVal(val.toLowerCase())}
        name="examreportToggle"
        value={examHistoryVal}
        icon={
          <PersonInMobileFilterIcon
            fill="white"
            style={{ width: "1.3rem", height: "1.3rem" }}
          />
        }
        icontype="svg"
        label="Girls"
      />
    </div>
  );
};
